import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const calculateBillingRateApi = createApi({
    reducerPath: 'calculateBillingRateApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['calculateBillingRate'],
    endpoints: builder => ({
        calculateBillingRate: builder.mutation({
            query: body => {
                return {
                    url: spotFinder.calculateBillingRateController.calculateBillingRate,
                    method: 'POST',
                    body: body.payload,
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                };
            },
        }),
        calculateExtraBilling: builder.mutation({
            query: body => {
                return {
                    url: spotFinder.calculateBillingRateController.calculateExtraBilling,
                    method: 'POST',
                    body: body.payload,
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                };
            },
        }),
    }),
});

export const { useCalculateBillingRateMutation , useCalculateExtraBillingMutation
} = calculateBillingRateApi;